var d={highlightedBackground:"Marked-module_highlightedBackground__YWqpJ"};export{d as default};
//# sourceMappingURL=Marked.module.scss.js.map
